import React, { useEffect, useRef } from "react";

export default function ObservationsField({
  label,
  value,
  onChange,
  maxHeight = 220,
  placeholder,
  disabled = false,
}) {
  const textareaRef = useRef(null);

  const resizeTextarea = () => {
    const element = textareaRef.current;
    if (!element) return;

    element.style.height = "auto";
    element.style.height = `${Math.min(element.scrollHeight, maxHeight)}px`;
    element.style.overflowY = element.scrollHeight > maxHeight ? "auto" : "hidden";
  };

  useEffect(() => {
    resizeTextarea();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <div>
      <label className="form-label">{label}</label>
      <textarea
        ref={textareaRef}
        className="form-control"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        rows={3}
        disabled={disabled}
        style={{ resize: "none", maxHeight: `${maxHeight}px` }}
      />
    </div>
  );
}
